<template>
<div class="chapter">
<div class="inner_page">
<div class="wrap">
<p class="image"><a id="page_1"></a><a id="page_2"></a><a id="page_3"></a><a id="f0002-01"></a><img alt="image" class="horizontal" src="images/f0002-01.jpg"/></p>
</div>
<p class="caption"><span class="brown1">Captain Will Wright of the Texas Rangers cooks his dinner over a campfire (circa 1930).</span></p>
<p class="caption_1_txt"><span class="brown1"><em>Photo: Texas State Library Archives Division</em></span></p>
<div class="wrap">
<p class="image"><a id="page_4"></a><a id="page_5"></a><a id="f0004-01"></a><img alt="image" class="horizontal" src="images/f0004-01.jpg"/></p>
</div>
<p class="caption"><span class="brown1">A barbecue stand made of corrugated tin, Corpus Christi, 1939.</span></p>
<p class="caption_1_txt"><span class="brown1"><em>Photo by Russell Lee</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02front.vue?b187debc